import { useFormContext } from 'react-hook-form';

import { FormControl, FormField, FormItem } from '@crossnokaye/ux-common';

import { DefrostScheduleBaseCellProps } from './defrost-schedule.types';
import { DefrostScheduleTimePicker } from './defrost-schedule-time-picker';
import { DefrostTableCell } from './defrost-table-cell';

export const DefrostScheduleTimeCell: React.FC<DefrostScheduleBaseCellProps> = ({ index }) => {
  const { control } = useFormContext();

  return (
    <DefrostTableCell>
      {(disabledByPermissions) => (
        <FormField
          control={control}
          name={`defrostSchedule.${index}.startTime`}
          render={({ field }) => (
            <FormItem className="flex flex-col">
              <FormControl>
                <DefrostScheduleTimePicker
                  date={field.value}
                  disabled={disabledByPermissions}
                  setDate={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />
      )}
    </DefrostTableCell>
  );
};
